import React from 'react';
import loadable from '@loadable/component';
import type { IGraphProps } from './types';

const LoadableComponent = loadable(
  () => import(/* webpackChunkName: "graph" */ './graph')
);

const GraphLoader = (props: IGraphProps) => <LoadableComponent {...props} />;

export default GraphLoader;
